export default "__VITE_ASSET__71269c76__"